import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { CookieNotice } from "../shared/ui/CookieNotice";

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <CookieNotice />
    </>
  );
}
